import {get} from '../utils'
import {getStoredChannel} from "../authentication/utils";

export default host => (type, id) =>
  get(`${host}${(getStoredChannel() && getStoredChannel().visibility === "public") ? "/public": ""}/channels/${getStoredChannel().id}/${type}/${id}/banners`)
    .then(response => response.json())
    .then(json => json.data)
